import { Routes, Route, Navigate } from "react-router-dom";
import "./App.css";
import Login from "./component/login/Login";
import HomePage from "./component/home/HomePage";
import { ROUTER_CONSTANT } from "./constant/router.constant";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route
          path={`/*`}
          element={<Navigate to={`/`} />}
        />
        <Route exact path={`/`} element={<Login />} />
        <Route exact path={`${ROUTER_CONSTANT.HOME}/*`} element={<HomePage />} />
      </Routes>
    </div>
  );
}

export default App;
